import Vue from "vue";
import Router from "vue-router";
// 使用路由
Vue.use(Router);
// 导出路由模块
export default new Router({
    routes: [{
            path: "/",
            redirect: "/login"
        },
        {
            path: "/index",
            component: () =>
                import ("@/pages/index/index.vue"),
            name: "index",
            redirect: "/home",
            children: [{
                    path: "/home",
                    component: () =>
                        import ("@/pages/home/index.vue"),
                    name: "home",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/index",
                    component: () =>
                        import ("@/pages/index/index.vue"),
                    name: "index",
                    redirect: "/home",
                    children: [{
                            path: "/home",
                            component: () =>
                                import ("@/pages/home/index.vue"),
                            name: "home",
                            meta: {
                                keepAlive: false // 不需要被缓存
                            }
                        },
                        {
                            path: "/staticInfo",
                            component: () =>
                                import ("@/pages/staticInfo/staticInfo.vue"),
                            name: "staticInfo",
                            meta: {
                                keepAlive: false // 不需要被缓存
                            }
                        },
                        {
                            path: "/staticPage",
                            component: () =>
                                import ("@/pages/staticPage/staticPage.vue"),
                            name: "staticPage",
                            meta: {
                                keepAlive: false // 不需要被缓存
                            }
                        },
                        // {
                        //     path: "/jobList",
                        //     component: () =>
                        //         import ("@/pages/jobList/jobList.vue"),
                        //     name: "jobList",
                        //     meta: {
                        //         keepAlive: false // 不需要被缓存
                        //     }
                        // },
                        // {
                        //     path: "/jobDetail",
                        //     component: () =>
                        //         import ("@/pages/jobList/jobDetail.vue"),
                        //     name: "jobDetail",
                        //     meta: {
                        //         keepAlive: false // 不需要被缓存
                        //     }
                        // },
                        {
                            path: "/evaluation",
                            component: () =>
                                import ("@/pages/evaluation/evaluation.vue"),
                            name: "evaluation",
                            meta: {
                                keepAlive: false // 不需要被缓存
                            }
                        },
                        {
                            path: "/evaInfo",
                            component: () =>
                                import ("@/pages/evaluation/evaInfo.vue"),
                            name: "evaInfo",
                            meta: {
                                keepAlive: false // 不需要被缓存
                            }
                        },
                        {
                            path: "/deliver",
                            component: () =>
                                import ("@/pages/deliver/deliver.vue"),
                            name: "deliver",
                            meta: {
                                keepAlive: true // 不需要被缓存
                            }
                        },
                        {
                            path: "/entryInfo",
                            component: () =>
                                import ("@/pages/entryInfo/entryInfo.vue"),
                            name: "entryInfo",
                            meta: {
                                keepAlive: false // 不需要被缓存
                            }
                        },
                        {
                            path: "/myWork",
                            component: () =>
                                import ("@/pages/myWork/myWork.vue"),
                            name: "myWork",
                            meta: {
                                keepAlive: false // 不需要被缓存
                            }
                        },
                        {
                            path: "/personInfo",
                            component: () =>
                                import ("@/pages/personInfo/personInfo.vue"),
                            name: "personInfo",
                            meta: {
                                keepAlive: false // 不需要被缓存
                            }
                        },
                        {
                            path: "/authentication",
                            component: () =>
                                import ("@/pages/authentication/authentication.vue"),
                            name: "authentication",
                            meta: {
                                keepAlive: false // 不需要被缓存
                            }
                        },
                        // {
                        //     path: "/authentication2",
                        //     component: () =>
                        //         import ("@/pages/authentication/authentication2.vue"),
                        //     name: "authentication2",
                        //     meta: {
                        //         keepAlive: false // 不需要被缓存
                        //     }
                        // },
                        // {
                        //     path: "/authentication3",
                        //     component: () =>
                        //         import ("@/pages/authentication/authentication3.vue"),
                        //     name: "authentication3",
                        //     meta: {
                        //         keepAlive: false // 不需要被缓存
                        //     }
                        // },
                        // {
                        //     path: "/authentication4",
                        //     component: () =>
                        //         import ("@/pages/authentication/authentication4.vue"),
                        //     name: "authentication4",
                        //     meta: {
                        //         keepAlive: false // 不需要被缓存
                        //     }
                        // },
                        // {
                        //     path: "/authentication5",
                        //     component: () =>
                        //         import ("@/pages/authentication/authentication5.vue"),
                        //     name: "authentication5",
                        //     meta: {
                        //         keepAlive: false // 不需要被缓存
                        //     }
                        // },
                        // {
                        //     path: "/authentication6",
                        //     component: () =>
                        //         import ("@/pages/authentication/authentication6.vue"),
                        //     name: "authentication6",
                        //     meta: {
                        //         keepAlive: false // 不需要被缓存
                        //     }
                        // },
                        // {
                        //     path: "/QA",
                        //     component: () =>
                        //         import ("@/pages/authentication/QA.vue"),
                        //     name: "QA",
                        //     meta: {
                        //         keepAlive: false // 不需要被缓存
                        //     }
                        // },
                        // {
                        //     path: "/pass",
                        //     component: () =>
                        //         import ("@/pages/authentication/pass.vue"),
                        //     name: "pass",
                        //     meta: {
                        //         keepAlive: false // 不需要被缓存
                        //     }
                        // },
                        // {
                        //     path: "/deliverDetail",
                        //     component: () =>
                        //         import ("@/pages/jobList/deliverDetail.vue"),
                        //     name: "deliverDetail",
                        //     meta: {
                        //         keepAlive: false // 不需要被缓存
                        //     }
                        // },
                        {
                            path: "/signIn",
                            component: () =>
                                import ("@/pages/signIn/signIn.vue"),
                            name: "signIn",
                            meta: {
                                keepAlive: false // 不需要被缓存
                            }
                        },




                    ]
                },
                {
                    path: "/staticInfo",
                    component: () =>
                        import ("@/pages/staticInfo/staticInfo.vue"),
                    name: "staticInfo",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/staticPage",
                    component: () =>
                        import ("@/pages/staticPage/staticPage.vue"),
                    name: "staticPage",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/jobList",
                    component: () =>
                        import ("@/pages/jobList/jobList.vue"),
                    name: "jobList",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/jobDetail",
                    component: () =>
                        import ("@/pages/jobList/jobDetail.vue"),
                    name: "jobDetail",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/evaluation",
                    component: () =>
                        import ("@/pages/evaluation/evaluation.vue"),
                    name: "evaluation",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/evaInfo",
                    component: () =>
                        import ("@/pages/evaluation/evaInfo.vue"),
                    name: "evaInfo",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/deliver",
                    component: () =>
                        import ("@/pages/deliver/deliver.vue"),
                    name: "deliver",
                    meta: {
                        keepAlive: true // 不需要被缓存
                    }
                },
                {
                    path: "/entryInfo",
                    component: () =>
                        import ("@/pages/entryInfo/entryInfo.vue"),
                    name: "entryInfo",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/myWork",
                    component: () =>
                        import ("@/pages/myWork/myWork.vue"),
                    name: "myWork",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/personInfo",
                    component: () =>
                        import ("@/pages/personInfo/personInfo.vue"),
                    name: "personInfo",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/authentication",
                    component: () =>
                        import ("@/pages/authentication/authentication.vue"),
                    name: "authentication",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/authentication2",
                    component: () =>
                        import ("@/pages/authentication/authentication2.vue"),
                    name: "authentication2",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                // {
                //     path: "/authentication3",
                //     component: () =>
                //         import ("@/pages/authentication/authentication3.vue"),
                //     name: "authentication3",
                //     meta: {
                //         keepAlive: false // 不需要被缓存
                //     }
                // },
                {
                    path: "/authentication4",
                    component: () =>
                        import ("@/pages/authentication/authentication4.vue"),
                    name: "authentication4",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/authentication5",
                    component: () =>
                        import ("@/pages/authentication/authentication5.vue"),
                    name: "authentication5",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/authentication6",
                    component: () =>
                        import ("@/pages/authentication/authentication6.vue"),
                    name: "authentication6",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/QA",
                    component: () =>
                        import ("@/pages/authentication/QA.vue"),
                    name: "QA",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/pass",
                    component: () =>
                        import ("@/pages/authentication/pass.vue"),
                    name: "pass",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/deliverDetail",
                    component: () =>
                        import ("@/pages/jobList/deliverDetail.vue"),
                    name: "deliverDetail",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/signIn",
                    component: () =>
                        import ("@/pages/signIn/signIn.vue"),
                    name: "signIn",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/personal",
                    component: () =>
                        import ("@/pages/personal/index.vue"),
                    name: "personal",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/orderDetail",
                    component: () =>
                        import ("@/pages/personal/orderDetail.vue"),
                    name: "orderDetail",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },

                {
                    path: "/user-setting",
                    component: () =>
                        import ("@/pages/user-setting/index.vue"),
                    name: "userSetting"
                },
                {
                    path: "/clockIn",
                    component: () =>
                        import ("@/pages/clockIn/index.vue"),
                    name: "clockIn",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/renzhengType",
                    component: () =>
                        import ("@/pages/home/renzhengType.vue"),
                    name: "renzhengType",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                },
                {
                    path: "/bullPerson",
                    component: () =>
                        import ("@/pages/authentication/bullPerson.vue"),
                    name: "bullPerson",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/message",
                    component: () =>
                        import ("@/pages/message/index.vue"),
                    name: "message",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/jobCenter",
                    component: () =>
                        import ("@/pages/perfectInfo/jobCenter.vue"),
                    name: "jobCenter",
                },
                {
                    path: "/chat",
                    component: () =>
                        import ("@/pages/chat/index.vue"),
                    name: "chat",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/demo",
                    component: () =>
                        import ("@/pages/perfectInfo/demo.vue"),
                    name: "demo",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/personCenter",
                    component: () =>
                        import ("@/pages/personCenter/personCenter.vue"),
                    name: "personCenter",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/myOrder",
                    component: () =>
                        import ("@/pages/myOrder/myOrder.vue"),
                    name: "myOrder",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/myOrderInfo",
                    component: () =>
                        import ("@/pages/myOrder/myOrderInfo.vue"),
                    name: "myOrderInfo",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/attendance",
                    component: () =>
                        import ("@/pages/attendance/attendance.vue"),
                    name: "attendance",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/income",
                    component: () =>
                        import ("@/pages/income/income.vue"),
                    name: "income",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }, {
                    path: "/cashOut",
                    component: () =>
                        import ("@/pages/income/cashOut.vue"),
                    name: "cashOut",
                    meta: {
                        keepAlive: false // 不需要被缓存
                    }
                }
            ]
        },
        {
            path: "/login",
            component: () =>
                import ("@/pages/login/index.vue"),
            name: "login"
        },
        {
            path: "/error",
            component: () =>
                import ("@/pages/error/error.vue"),
            name: "error"
        },
        {
            path: "/staticInfo1",
            component: () =>
                import ("@/pages/staticInfo/staticInfo1.vue"),
            name: "staticInfo1"
        },
        {
            path: "/staticInfo2",
            component: () =>
                import ("@/pages/staticInfo/staticInfo2.vue"),
            name: "staticInfo2"
        },
        {
            path: "/staticInfo3",
            component: () =>
                import ("@/pages/staticInfo/staticInfo3.vue"),
            name: "staticInfo3"
        },
        {
            path: "/staticInfo4",
            component: () =>
                import ("@/pages/staticInfo/staticInfo4.vue"),
            name: "staticInfo4"
        },
        {
            path: "/staticInfo5",
            component: () =>
                import ("@/pages/staticInfo/staticInfo5.vue"),
            name: "staticInfo5"
        },
        {
            path: "/staticInfo6",
            component: () =>
                import ("@/pages/staticInfo/staticInfo6.vue"),
            name: "staticInfo6"
        },
        {
            path: "/perfectInfo1",
            component: () =>
                import ("@/pages/perfectInfo/perfectInfo1.vue"),
            name: "perfectInfo1",
            meta: {
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: "/perfectInfo2",
            component: () =>
                import ("@/pages/perfectInfo/perfectInfo2.vue"),
            name: "perfectInfo2",
            meta: {
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: "/perfectInfo3",
            component: () =>
                import ("@/pages/perfectInfo/perfectInfo3.vue"),
            name: "perfectInfo3",
            meta: {
                keepAlive: false // 需要被缓存
            }
        }, {
            path: "/updateCV",
            component: () =>
                import ("@/pages/perfectInfo/updateCV.vue"),
            name: "updateCV",
            meta: {
                keepAlive: false // 需要被缓存
            }
        },
        {
            path: "/authentication3",
            component: () =>
                import ("@/pages/authentication/authentication3.vue"),
            name: "authentication3",
            meta: {
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: "/workExperience",
            component: () =>
                import ("@/pages/perfectInfo/workExperience.vue"),
            name: "workExperience",
            meta: {
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: "/inreview",
            component: () =>
                import ("@/pages/perfectInfo/inreview.vue"),
            name: "inreview",
            meta: {
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: "/auditStatus",
            component: () =>
                import ("@/pages/perfectInfo/auditStatus.vue"),
            name: "auditStatus",
            meta: {
                keepAlive: false // 不需要被缓存
            }
        },
        {
            path: "/createInfo",
            component: () =>
                import ("@/pages/createInfo/index.vue"),
            name: "createInfo"
        },
        {
            path: "/perfectInfo",
            component: () =>
                import ("@/pages/perfectInfo/perfectInfo.vue"),
            name: "perfectInfo"
        },
        {
            path: "/perfectInfo4",
            component: () =>
                import ("@/pages/perfectInfo/perfectInfo4.vue"),
            name: "perfectInfo4"
        },
        {
            path: "/authenticationInfo",
            component: () =>
                import ("@/pages/perfectInfo/authenticationInfo.vue"),
            name: "authenticationInfo"
        },
        {
            path: "/ceping",
            component: () =>
                import ("@/pages/perfectInfo/ceping.vue"),
            name: "ceping"
        },
    ],
    scrollBehavior: () => ({ y: 0 }),
});


// WEBPACK FOOTER //
// ./src/router/index.js